import { countries, statesByCountry } from './geo.generated';

export interface GeoOption { code: string; name: string }

export const countryOptions: readonly GeoOption[] = countries;
export const statesForCountry = (countryCode: string): readonly GeoOption[] =>
  statesByCountry[countryCode] ?? [];
export const countryByCode = (countryCode: string) =>
  countries.find((country) => country.code === countryCode);
export const stateByCode = (countryCode: string, stateCode: string) =>
  statesForCountry(countryCode).find((state) => state.code === stateCode);

type CitiesByState = Readonly<Record<string, readonly string[]>>;
const cityCache = new Map<string, Promise<CitiesByState>>();

export function citiesForCountry(countryCode: string): Promise<CitiesByState> {
  if (!countryCode) return Promise.resolve({});
  const existing = cityCache.get(countryCode);
  if (existing) return existing;
  const request = fetch(`/geo/cities/${encodeURIComponent(countryCode)}.json`)
    .then((response) => {
      if (!response.ok) throw new Error(`geo.citiesLoadFailed:${countryCode}`);
      return response.json() as Promise<CitiesByState>;
    });
  cityCache.set(countryCode, request);
  return request;
}
